<template>
  <div class="page-width">
    <div v-if="!businessRegistrationSuccessful && !businessRegistrationLoading" element-loading-spinner="spinner" class="sign-container">
      <div class="mobile-signin-header">
        <h4 class="mobile-registered">Create <span class="first-word">New Business</span> Account</h4>
        <p class="mobile-signin-note">
          Tell us a little about your business so we can verify it. Have multiple locations? Use the address shown on official documents like tax forms.
        </p>
      </div>
      <el-form class="register-container" :model="businessForm" @keyup.enter.native="businessRegister(businessForm)">
        <p v-if="businessErrors.length || businessRegistrationError" style='padding-bottom: 20px'>
          <b>{{ $t('followingErrors') }}</b>
          <ul style="color: red">
            <li>{{businessRegistrationError}}</li>
            <li v-for="error in businessErrors">{{ error }}</li>
          </ul>
        </p>
        <div class="name-container">
          <el-input class="register-modal-first" placeholder="First Name*" v-model="b2bFirstName" ></el-input>
          <el-input class="register-modal-last" placeholder="Last Name*" v-model="b2bLastName" ></el-input>
        </div>
        <el-input class="register-modal-input" placeholder="Business Name*" v-model="businessForm.business_name" ></el-input>
        <el-input class="register-modal-input" placeholder="Business Email*" v-model="businessForm.email" ></el-input>
        <el-input class="register-modal-input" placeholder="Business Phone*" v-model="businessForm.phone_number" ></el-input>
        <el-input class="register-modal-input" placeholder="Address*" v-model="businessForm.street" ></el-input>
        <div class="name-container">
          <el-input class="register-modal-first" placeholder="City*" v-model="businessForm.city" ></el-input>
          <el-input class="register-modal-last" placeholder="Apt/Suite/Unit (Optional)" v-model="businessForm.suit_unit" ></el-input>
        </div>
        <div class="name-container">
          <el-input class="register-modal-first" placeholder="Zipcode*" v-model="businessForm.zipcode" ></el-input>
          <el-input class="register-modal-last" placeholder="Country*" v-model="businessForm.country" ></el-input>
        </div>
        <el-input class="register-modal-input" placeholder="State*" v-model="businessForm.state" ></el-input>
        <!-- <div class="business-container">
          <el-form-item class="business-select-mobile">
            <el-select v-model="businessForm.business_type" v-bind:placeholder="$t('Type of Business')" value="">
              <el-option
                v-for="item in businessTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  class="business-select-mobile">
            <el-input v-model="businessForm.ein" autocomplete="new-password" placeholder="Federal Tax ID Number">C</el-input>
          </el-form-item>
          <el-form-item class="biz-container">
            <div class="select-container">
              <p class="business-select">Are you a retailer?</p>
              <el-radio-group  v-model="businessForm.is_retailer">
                <el-radio :label="true">Yes</el-radio>
                <el-radio :label="false">No</el-radio>
              </el-radio-group>
            </div>
            <el-input :style="'marginBottom: 10px'" autocomplete="new-password" v-if="businessForm.is_retailer" v-model="businessForm.resale_no" placeholder="Resale License Number"></el-input>
          </el-form-item>
          <div>
            <el-form-item class="business-select-mobile"  autocomplete="new-password">
              <el-input :style="'marginBottom: 10px'" v-model="businessForm.dun_brad_no" placeholder="Dun & Bradstreet Number (Optional)"></el-input>
              <el-input autocomplete="new-password" v-model="businessForm.business_year" placeholder="Years in Business"></el-input>
            </el-form-item>
          </div>
        </div> -->
        <p class="terms-conditions">
          By submitting and creating this business account, you agree to the <span class="first-word">Elegant Granite Business Account Terms and Conditions</span>.
        </p>
        <el-button class="register-button" type="submit" @click="businessRegister(businessForm)">
        <!-- {{ $t('create') }}
        -->
         Create Business Account and Submit
        </el-button>
      </el-form>
    </div>
    <div v-else-if="businessRegistrationLoading && !businessRegistrationSuccessful">
      <loading />
    </div>
    <div v-else-if="businessRegistrationSuccessful && !businessRegistrationLoading" class="sign-container">
      <div class="business-header-container">
        <h4 class="business-header">We're verifying your info</h4>
        <p class="business-info">
          It takes 24 hours to verify your business info. We will email you soon. Thank you.
        </p>
        <img class="business-image-mobile" src="../../assets/img/Asset_1@2x.png" />
        <div class="arrow-container">
          <p @click="goToHome()">Go to Home page <p class="arrow-mobile">&gt;</p></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { isUserAuthenticated } from '../../store/modules/cart';
import loading from '../loading';
export default {
  name: 'confirmation',
  components: {
    loading
  },
  data() {
    return {
      errors: [],
      businessErrors: [],
      businessForm: {
        full_name: '',
        business_name: '',
        phone_number: '',
        street: '',
        email: '',
        suit_unit: '',
        zipcode: '',
        country: '',
        state: '',
        // business_type: '',
        // ein: '',
        // ssn: '',
        // is_retailer: '',
        // resale_no: '',
        // dun_brad_no: '',
      },
      b2bFirstName: '',
      b2bLastName: '',
      email:'',
      login: true, //true showlogin; false forget password
      showModal: false,
      verification: '',
      businessTypes: [
        { value: 'C-Corp', label: "C-Corp" },
        { value: 'S-Corp', label: "S-Corp" },
        { value: 'LLC', label: "LLC" },
        { value: 'Sole Proprietor', label: "Sole Proprietor" },
      ]
    }
  },
  methods: {
    ...mapActions('auth', ['LoginRequest', 'checkUsername', 'resetEmail', 'sentVerificationCode', 'resetPassword', 'registerBusinessCustomer', 'checkEmail', 'registerRequest']),
    ...mapMutations('auth', ['userRegistered', 'registeringUser', 'registerError']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    goToHome() {
      this.$router.push('/')
    },
    businessRegister: async function(form) {
      // if (!form.is_retailer) {
      //   delete form.is_retailer
      // }
      form.full_name = this.b2bFullName;
      await this.checkBusinessRegistration(form);
      if(!this.businessErrors.length) {
        this.registerBusinessCustomer(form)
        .catch( err => {
          this.businessErrors = [];
          this.businessErrors.push(this.$t('errorCreateAccount'));
        })
      }
    },
    checkBusinessRegistration: async function(form) {
      // const emailBeenTaken = await this.checkUsername({ username: form.email });
      this.businessErrors = [];
      if (!this.b2bFirstName) {
        this.businessErrors.push(this.$t('firstNameRequired'));
      };
      if(!this.b2bLastName) {
        this.businessErrors.push(this.$t('lastNameRequired'));
      };
      if(!form.business_name) {
        this.businessErrors.push(this.$t('Business Name required'))
      };
      if (!form.phone_number) {
        this.businessErrors.push(this.$t('Please enter a valid phone number.'))
      };
      if (!form.street) {
        this.businessErrors.push('Please enter a valid address');
      }
      if (!form.city) {
        this.businessErrors.push('Please enter a valid city');
      }
      if (!form.zipcode) {
        this.businessErrors.push('Please enter a valid zipcode');
      }
      if (!form.country) {
        this.businessErrors.push('Please enter a valid country');
      }
      if (!form.state) {
        this.businessErrors.push('Please enter a valid state');
      }
      // if (!form.business_type) {
      //   this.businessErrors.push('Please select a valid business type.')
      // }
      // if (!form.ein) {
      //   this.businessErrors.push("Please enter a Federal Tax ID Number.")
      // }
      // if ((form.business_type !=="C-Corp" && !form.ssn) || (form.business_type !== "C-Corp" && form.ssn.length !== 9)) {
      //   this.businessErrors.push("Please enter a valid Social Security Number.")
      // }
      // if (form.is_retailer === '') {
      //   this.businessErrors.push("Please select a valid retailer option.")
      // }
      // if (form.is_retailer && !form.resale_no) {
      //   this.businessErrors.push("Please enter a valid Resale License Number.")
      // }
      // if (form.dun_brad_no.length && form.dun_brad_no.length !== 9) {
      //   this.businessErrors.push("Dun & Bradstreet numbers must be 9 digits in length.")
      // }
      // if (!form.business_year) {
      //   this.businessErrors.push("Please enter a valid year amount.")
      // }
      if (!form.email) {
        this.businessErrors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.email)) {
        this.businessErrors.push(this.$t('emailValidRequired'));
      } else {
        const res = await this.checkEmail({ email: form.email })
        if (res.data.isTaken) {
          this.businessErrors.push(this.$t('emailTaken'))
        }
      }
    },
    clearOldValues() {
      // this.businessForm.ein = '';
      // this.businessForm.ssn = '';
    },
  },
  computed: mapState({
    businessRegistrationLoading: state => state.auth.businessRegistrationLoading,
    businessRegistrationSuccessful: state => state.auth.businessRegistrationSuccessful,
    businessRegistrationError: state => state.auth.businessRegistrationError,
    b2bFullName() {
      return this.b2bFirstName + ' ' + this.b2bLastName;
    },
  }),
}
</script>

<style scoped lang="less">
@import "../../assets/css/signUpModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Auth/b2bRegister.vue